// src/main.tsx
// Application entry point — wires together Provider, AppInitializer, RouterProvider, and Toaster.
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createPortal } from 'react-dom'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { store } from '@/app/store'
import AppInitializer from '@/components/AppInitializer'
import { AuthProvider } from '@/context/AuthContext'
import router from '@/router'
import '@/index.css'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('[Dualon] Root element #root not found. Check index.html.')
}

createRoot(rootElement).render(
  <StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <AppInitializer>
          <RouterProvider router={router} />
          {createPortal(
            <Toaster
              position="top-right"
              containerStyle={{
                zIndex: 999999,
              }}
              toastOptions={{
                duration: 4000,
                style: {
                  fontFamily: 'Montserrat, Inter, sans-serif',
                  fontSize: '14px',
                  fontWeight: '500',
                  borderRadius: '10px',
                  boxShadow: '0 4px 24px 0 rgba(15, 23, 42, 0.12)',
                },
                success: { iconTheme: { primary: '#2EC69D', secondary: '#fff' } },
                error: { iconTheme: { primary: '#ef4444', secondary: '#fff' } },
              }}
            />,
            document.body
          )}
        </AppInitializer>
      </AuthProvider>
    </Provider>
  </StrictMode>
)
